module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Team"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-4 content has-text-white"
  }, [_c('img', {
    attrs: {
      "width": "320px",
      "src": "/static/img/team/matej_nemcek.jpg"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "has-text-white"
  }, [_vm._v("\n        Matej Nemček\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Founder & Growth\n      ")]), _vm._v(" "), _vm._l((_vm.socialsYangwao.slice(0, 3)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  }), _c('br'), _vm._v(" "), _vm._l((_vm.socialsYangwao.slice(3, 6)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column is-4 content has-text-white"
  }, [_c('img', {
    attrs: {
      "width": "320px",
      "src": "/static/img/team/anett_rolikova.jpg"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "has-text-white"
  }, [_vm._v("\n        Anett Rolikova\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Events & Operations\n      ")]), _vm._v(" "), _vm._l((_vm.socialsAnett.slice(0, 3)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  }), _c('br'), _vm._v(" "), _vm._l((_vm.socialsAnett.slice(3, 6)), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08fbca5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 237
// module chunks = 13